import {z} from 'zod';

const SalesTargetItemSchema = z.object({
  id: z.number().nullable().catch(null),
  salesTargetName: z.string().catch(''),
  eligibleStoresCount: z.number().nullable().catch(null),
  percentTargetAchieved: z.number().nullable().catch(null),
  pointsAwarded: z.number().nullable().catch(null),
  startDate: z.string().nullable().optional(),
  endDate: z.string().nullable().optional(),
  status: z.string().nullable().catch(null),
  reportUrl: z.string().nullable().catch(null),
  lastUpdatedDate: z.string().nullable().catch(null),
  updatedBy: z.string().catch(''),
  uuid: z.string().nullable().catch(null),
  type: z.string().nullable().catch(null)
});

const SalesTargetResponseSchema = z.object({
  data: z.array(SalesTargetItemSchema).optional(),
  totalRecords: z.union([z.string(), z.number()]).catch(''),
  totalPages: z.union([z.string(), z.number()]).catch(''),
  activeCount: z.union([z.string(), z.number()]).catch(''),
  currentPage: z.union([z.string(), z.number()]).catch(''),
  pageSize: z.union([z.string(), z.number()]).catch(''),
  sortBy: z.string().catch(''),
  order: z.string().catch('')
});

export const GetFormattedSalesTargetData = (apiResponse = {}) => {
  const result = SalesTargetResponseSchema.safeParse(apiResponse);

  if (!result.success) {
    return {};
  }

  const parsed = result.data;

  return {
    data: parsed.data?.map((item) => SalesTargetItemSchema.parse(item)),
    totalRecords: parsed.totalRecords,
    totalPages: parsed.totalPages,
    activeCount: parsed.activeCount,
    currentPage: parsed.currentPage,
    pageSize: parsed.pageSize,
    sortBy: parsed.sortBy,
    order: parsed.order
  };
};
